import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomAction } from "../../store/customAction";
import { Api } from "../../";
import {
  IAgentPoliciesRequestBody,
  IAgentPoliciesListingResponse,
} from "../../models/agent/policiesListing";
import { API_POST_AGENT_POLICIES } from "../../Apis/ApiEndPoints";

export const GetAgentPolicies = createAsyncThunk(
  "agent/policies",
  async (requestBody: IAgentPoliciesRequestBody, { dispatch }) => {
    const response: IAgentPoliciesListingResponse = await CustomAction(
      Api.post(API_POST_AGENT_POLICIES, requestBody),
      dispatch,
      "agent/policies"
    );

    return response;
  }
);
